import React from "react";
import { useMediaQuery } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import MobileBookingCalendar from "../admin/MobileBookingCalendar";
import BookingCalendar from "../admin/bookingCalendar";

const BarberAppointments = () => {
  const { user } = useAuth();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const lockedBarber = user
    ? { user_id: user.user_id, first_name: user.first_name, last_name: user.last_name }
    : null;

  return isMobile
    ? <MobileBookingCalendar lockedBarber={lockedBarber} />
    : <BookingCalendar lockedBarber={lockedBarber} />;
};

export default BarberAppointments;
